module.exports = __webpack_public_path__ + "img/patron_ciudad.10e89b92.png";